
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 16 16\" id=\"icon_green_person_jax_54c857f18c6c2ca24fa13de8eece15b9\" > <path d=\"M8 9.42405C5.53569 9.42405 3.53797 7.42633 3.53797 4.96203C3.53797 2.49772 5.53569 0.5 8 0.5C10.4643 0.5 12.462 2.49772 12.462 4.96203C12.462 7.42633 10.4643 9.42405 8 9.42405ZM0.5 15.5V15.2152C0.5 11.3496 3.66169 8.85443 8 8.85443C12.339 8.85443 15.5 11.3493 15.5 15.2152V15.5H0.5Z\" fill=\"#2CD4AE\"/> </symbol>";
module.exports = sprite.add(image, "icon_green_person_jax_54c857f18c6c2ca24fa13de8eece15b9");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_green_person.svg
// module id = 1747
// module chunks = 1